<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs >
        <a-tab-pane key="1" tab="订单统计">
          <orderlist></orderlist>
        </a-tab-pane>
        <a-tab-pane key="2" tab="客户构成">
          <customerList></customerList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import orderlist from './components/order_list';
import customerList from './components/customer_list';
export default {
  components: {orderlist,customerList },
  setup(props) {
    const state = reactive({
      
    });
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    
    onMounted(() => {
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>